(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('TemplateProductSavedModalCtrl', templateProductSavedModalCtrl);

    function templateProductSavedModalCtrl($scope, $mdDialog, templateId, forMyProductBases) {
        $scope.templateId = templateId;
        $scope.titleSaved = 'Product Base Saved';
        $scope.goToTemplateProducts = function () {
            $mdDialog.hide();
        };
    }
})();
